import { Grid, Stack } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorAlertNotification } from '../../common/ErrorHandling/ErrorAlertNotification';
import { styles } from '../../style/style';
import { ChargeToBacLabel, ChargeToBacText, ChargeToBfc, ClearButton, EndUserFan, ModelYear, OrderSummaryAppName, PrimaryFanLabel, PrimaryFanText, SearchButton, ShipToBac } from './OrderSummaryComponents';
import { setOrderSummaryDataList, setSearchFieldList } from './orderSummarySlice';
import OrderSummaryTable from './OrderSummaryTable';
import { useIntl } from 'react-intl';
import log from '../../common/components/Logger'


export default function OrderSummary() {
    const login = useSelector((state) => state.login.data.payload.login);

    if (!login) {
        window.location.href = '/home';
    }



    const intl = useIntl();
    const dispatch = useDispatch();
    const [primaryFan, setPrimaryFan] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.primaryFan));
    const [bacNumber, setBacNumber] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.chargeToBac));
    const [endUserFan, setEndUserFan] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.endUserFan));
    const [chargeBfc, setChargeBfc] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.chargeToBfc));
    const [shipBac, setShipBac] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.shipToBac));
    const [selectedYear, setSelectedYear] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.modelYear));
    const [error, setError] = useState(true);
    const [cleared, setCleared] = useState(false);
    const [modelYear, setModelYear] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [invalidChargeToBacMessage, setInvalidChargeToBacMessage] = useState("");
    const [invalidChargeToBfcMessage, setInvalidChargeToBfcMessage] = useState("");
    const [invalidEndUserFanMessage, setInvalidEndUserFanMessage] = useState("");
    const [invalidPrimaryFanMessage, setInvalidPrimaryFanMessage] = useState("");
    const [invalidShipToBacMessage, setInvalidShipToBacMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [modelYearRequired, setModelYearRequired] = useState("");
    const ApiList = useSelector((state) => state.apiList.apiList);
    const [open, setOpen] = useState(false);
    const [errorType, setErrorType] = useState("");
    const dataListItem = useSelector((state) => state.searchFieldList.orderSummaryData.payload);
    const userDetails = useSelector((state) => state.user.data.payload);
    const idToken = localStorage.getItem("idToken")
    const [gdlError, setGdlError] = useState("");
    const url = ApiList.getsearchinputbyrole;
    let styleByPartnerType;
    const [userData, setUserData] = useState({
        user: {
            userId: userDetails.userId,
            partnerType: userDetails.partnerType,
            preferredLanguage: userDetails.preferredLanguage,
            bac: userDetails.bac,
            primaryFan: userDetails.primaryFAN
        }
    });

    const [apiConfig, setApiConfig] = useState({
        headers: {
            method: 'POST',
            'Content-Type': 'application/json',
            'guid': `${ApiList.guid}`
        }
    });


    useEffect(() => {
        axios.post(url, userData, apiConfig)
            .then((response) => {
                if (!cleared) {
                }
                if (response.status === 200) {
                    log.info(`fos_ui_log: OrderSummary():getsearchinputbyrole ${response.data.statusMessage}`)
                    setError(false)
                    if (response.data.bacFixed === true) {
                        document.getElementById("chargeToBacGridLabel").style.display = 'block';
                        setBacNumber(response.data.bac);
                    } else {
                        document.getElementById("chargeToBacGridText").style.display = 'block';
                    }

                    if (response.data.primaryFanFixed === true) {
                        document.getElementById("primaryFanLabel").style.display = 'block';
                        setPrimaryFan(response.data.primaryFan);
                    } else {
                        document.getElementById("primaryFanText").style.display = 'block';
                    }

                    if (response.data.hideEndUserFan === false) {
                        document.getElementById("endUserFanGrid").style.display = 'block';
                    }
                }
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    document.getElementById("chargeToBacGridText").style.display = 'block';
                    document.getElementById("chargeToBacGridText").style.display = 'block';
                    document.getElementById("primaryFanText").style.display = 'block';
                    document.getElementById("endUserFanGrid").style.display = 'block';
                    setError(true)
                    log.error(`fos_ui_log: OrderSummary():getsearchinputbyrole ${error.message}`)
                }
                else {
                    setError(true);
                    log.error(`fos_ui_log: OrderSummary():getsearchinputbyrole ${error.message}`)
                    setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                }
            })
    }, [bacNumber, primaryFan]);

    useEffect(() => {
        if (userDetails.partnerType !== 'GM_Corporate' && userDetails.partnerType !== 'GM_Wholesale' && userDetails.partnerType !== 'FLEET' && userDetails.partnerType !== 'FLEETDEALER') {
            axios.post(ApiList.getDealerInfo, userData, apiConfig)
                .then((response) => {
                    if (response.data.statusMessage !== null && response.data.statusMessage !== "Success") {
                        setGdlError(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                        log.info(`fos_ui_log: OrderSummary():getdealerinfo: ${response.data.statusMessage}`)
                    }
                    log.info(`fos_ui_log: OrderSummary():getdealerinfo: ${response.data.statusMessage}`)
                    return (response.data.userProfile)
                })
                .then((dealer) => {
                    setCompanyName("for " + dealer.dealerList[0].companyName)
                }).catch(err => log.error(`fos_ui_log: OrderSummary():getdealerinfo: ${err}`))
        } else if (userDetails.partnerType === 'FLEET' || userDetails.partnerType === 'FLEETDEALER') {
            setCompanyName("for " + userDetails.name)
        }
        else {
            setCompanyName("")
        }
    }, []);

    useEffect(() => {
        axios.get(ApiList.getModelYear, apiConfig)
            .then((res) => {
                setModelYear(res.data.activeYears)
                log.info(`fos_ui_log: OrderSummary():getmodelyear: ${res.data.statusMessage}`)
                if (selectedYear == "") { 
                    setSelectedYear([res.data.activeYears[res.data.activeYears.length - 1]])
                }
            }).catch(err => log.error(`fos_ui_log: OrderSummary():getmodelyear: ${err}`))
    }, []);


    const formValidation = async () => {
        const url = ApiList.formValidation;
        const formData = {
            orderSummarySearch: {
                primaryFleetAccountNumber: primaryFan,
                endUserFleetAccountNumber: endUserFan,
                chargeToBac: bacNumber,
                chargeToBfc: chargeBfc,
                shipToBac: shipBac,
                modelYear: selectedYear.toString(),
                partnerType: userDetails.partnerType
            }
        }

        const response = await axios
            .post(url, formData, apiConfig)
            .then((res => {
                log.info(`fos_ui_log: OrderSummary():formValidation: Success data fetched`)
                dispatch(setOrderSummaryDataList(res.data.allocationGroupList));
                if (res.data.statusMessage !== null) {
                    setStatusMessage(intl.formatMessage({ id: res.data.statusMessage, defaultMessage: "Error Found" }))
                    log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.statusMessage}`)
                    setErrorType('error')
                    setInvalidChargeToBacMessage("");
                    setInvalidChargeToBfcMessage("");
                    setInvalidEndUserFanMessage("");
                    setInvalidPrimaryFanMessage("");
                    setInvalidShipToBacMessage("");
                    setOpen(true);
                } else {
                    setStatusMessage("")
                    if (res.data.invalidChargeToBacMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidChargeToBacMessage} : ${bacNumber}`)
                        setInvalidChargeToBacMessage(intl.formatMessage({ id: res.data.invalidChargeToBacMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidChargeToBacMessage("")
                    }
                    if (res.data.invalidChargeToBfcMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidChargeToBfcMessage} : ${chargeBfc}`)
                        setInvalidChargeToBfcMessage(intl.formatMessage({ id: res.data.invalidChargeToBfcMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidChargeToBfcMessage("")
                    }
                    if (res.data.invalidEndUserFanMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidEndUserFanMessage} : ${endUserFan}`)
                        setInvalidEndUserFanMessage(intl.formatMessage({ id: res.data.invalidEndUserFanMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidEndUserFanMessage("")
                    }
                    if (res.data.invalidPrimaryFanMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidPrimaryFanMessage} : ${primaryFan}`)
                        setInvalidPrimaryFanMessage(intl.formatMessage({ id: res.data.invalidPrimaryFanMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidPrimaryFanMessage("")
                    }
                    if (res.data.invalidShipToBacMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidShipToBacMessage} : ${shipBac}`)
                        setInvalidShipToBacMessage(intl.formatMessage({ id: res.data.invalidShipToBacMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidShipToBacMessage("");
                    }
                }
            }))
            .catch((error) => {
                setOpen(true);
                setErrorType('error')
                log.error(`fos_ui_log: OrderSummary():formValidation: ${error.message}`)
                setStatusMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
            })
    }


    /*  let gridSize;
     if (userData.partnerType === "FLEET") {
         gridSize = 4;
     } else {
         gridSize = 3;
     } */

    const SubmitHandler = (e) => {
        e.preventDefault()
        formValidation()
        if (selectedYear.length === 0) {
            setModelYearRequired(intl.formatMessage({ id: "ordersummary.modelYearRequired", defaultMessage: "Model Year is Required" }))
        } else {
            setModelYearRequired("")
        }
        dispatch(setSearchFieldList({
            primaryFan: primaryFan,
            chargeToBac: bacNumber,
            endUserFan: endUserFan,
            modelYear: selectedYear,
            chargeToBfc: chargeBfc,
            shipToBac: shipBac
        }));
    }

    const clearForm = () => {
        setCleared(true);
        setBacNumber("")
        setPrimaryFan("");
        setEndUserFan("");
        setChargeBfc("");
        setShipBac("");
        setSelectedYear([]);
        setInvalidChargeToBacMessage("");
        setInvalidChargeToBfcMessage("");
        setInvalidEndUserFanMessage("");
        setInvalidPrimaryFanMessage("");
        setInvalidShipToBacMessage("");
        setStatusMessage("");
        setModelYearRequired("")
        dispatch(setOrderSummaryDataList());
        dispatch(setSearchFieldList({
            primaryFan: '',
            chargeToBac: '',
            endUserFan: '',
            modelYear: [],
            chargeToBfc: '',
            shipToBac: ''
        }));

    }

    const onChangePrimaryFan = (event) => {
        setPrimaryFan(event.target.value);
    }
    const onChangeEndUserFan = (event) => {
        setEndUserFan(event.target.value);
    }
    const onChangeChargeBfc = (event) => {
        setChargeBfc(event.target.value);
    }
    const onChangeShipBac = (event) => {
        setShipBac(event.target.value);
    }
    const onChangeChargeToBac = (event) => {
        setBacNumber(event.target.value);
    }
    const handleCheck = (e) => {
        const {
            target: { value },
        } = e;
        setSelectedYear(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };



    if (userDetails.partnerType === "FLEETDEALER") {
        styleByPartnerType = styles.orderSummaryStack_2
    } else if (userDetails.partnerType === "DEALER" || userDetails.partnerType === "UPFITTER") {
        styleByPartnerType = styles.orderSummaryStack_3
    } else if (userDetails.partnerType === "FLEET") {
        styleByPartnerType = styles.orderSummaryStack_4
    } else {
        styleByPartnerType = styles.orderSummaryStack_5
    }



    if (error === true && errorMessage !== "") {
        return (
            <ErrorAlertNotification errorMessage={errorMessage} />
        )
    } else {
        return (
            <Box sx={{ mb: '5%' }}>
                {gdlError !== "" &&
                    <ErrorAlertNotification errorMessage={gdlError} />
                }
                <Grid container sx={styles.masterMargin}>
                    <Grid item xs={12}>
                        <Grid hidden={error === true}>
                            <OrderSummaryAppName companyName={companyName} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack spacing={2} direction='row' sx={styles.orderSummaryStack}>
                            <Box sx={{ width: '25%' }} hidden id='chargeToBacGridLabel'>
                                <ChargeToBacLabel bacNumber={bacNumber} />
                            </Box>
                            <Box sx={{ width: '25%' }} hidden id='chargeToBacGridText'>
                                <ChargeToBacText value={bacNumber} error={invalidChargeToBacMessage} id='chargeToBac' onChangeChargeToBac={onChangeChargeToBac} />
                            </Box>
                            <Box sx={{ width: '25%' }} hidden id='primaryFanText'>
                                <PrimaryFanText value={primaryFan} error={invalidPrimaryFanMessage} id='primaryFan' onChangePrimaryFan={onChangePrimaryFan} />
                            </Box>
                            <Box sx={{ width: '25%' }} hidden id='primaryFanLabel'>
                                <PrimaryFanLabel primaryFan={primaryFan} partnerType={userDetails.partnerType} />
                            </Box>

                            <Box sx={{ width: '25%' }} hidden id='endUserFanGrid'>
                                <EndUserFan value={endUserFan} error={invalidEndUserFanMessage} id='endUserFan' onChangeEndUserFan={onChangeEndUserFan} />
                            </Box>
                            <Box sx={{ width: '25%' }} hidden={error === true}>
                                <ModelYear modelYearRequired={modelYearRequired} selectedYear={selectedYear} options={modelYear} handleCheck={handleCheck} />
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack spacing={2} direction='row' sx={styleByPartnerType}>
                            <Box sx={{ width: '25%' }} hidden={error === true}>
                                <ChargeToBfc value={chargeBfc} error={invalidChargeToBfcMessage} id='chargeBfc' onChangeChargeBfc={onChangeChargeBfc} />
                            </Box>
                            <Box sx={{ width: '25%' }} hidden={error === true}>
                                <ShipToBac value={shipBac} error={invalidShipToBacMessage} id='shipBac' onChangeShipBac={onChangeShipBac} />
                            </Box>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} hidden={error === true}>
                        <Stack direction='row' spacing={2} sx={styles.orderSummaryStackButton}>
                            <ClearButton clearForm={clearForm} />
                            <SearchButton
                                statusMessage={statusMessage}
                                invalidChargeToBacMessage={invalidChargeToBacMessage}
                                invalidChargeToBfcMessage={invalidChargeToBfcMessage}
                                invalidEndUserFanMessage={invalidEndUserFanMessage}
                                invalidPrimaryFanMessage={invalidPrimaryFanMessage}
                                invalidShipToBacMessage={invalidShipToBacMessage}
                                errorType={errorType}
                                open={open} handleClose={handleClose} submitHandler={SubmitHandler} />
                        </Stack>
                    </Grid>
                    {dataListItem !== null && dataListItem !== undefined &&

                        <Grid item xs={12}>
                            <Box>
                                <OrderSummaryTable
                                    chargeToBac={bacNumber}
                                    primaryFleetAccountNumber={primaryFan}
                                    partnerType={userDetails.partnerType}
                                    endUserFleetAccountNumber={endUserFan}
                                    chargeToBfc={chargeBfc}
                                    shipToBac={shipBac}
                                    modelYear={selectedYear}
                                />
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Box >
        )
    }
}
